"use client";
import axios from "axios";
import useSWR from "swr";

const API = process.env.NEXT_PUBLIC_API_BASE_URL;

export interface Representative {
  id: string;
  userId?: string;
  institutionName: string;
  institutionType: string | null;
  logo: string | null;
  description: string;
  websiteUrl: string | null;
  contactEmail: string;
  country: string;
  fieldsOffered: string[];
  countriesAccepting: string[];
  servicesOffered?: string[];
  user: { firstName: string; lastName: string };
  createdAt?: string;
  updatedAt?: string;
  isAvailableForHire?: boolean;
}

const fetcher = (url: string) => axios.get(url).then((r) => r.data);

export function useRepresentatives() {
  const { data, isLoading } = useSWR(
    `${API}/representatives`,
    fetcher,
    { revalidateOnFocus: false, dedupingInterval: 30000 }
  );

  const rawReps = (data?.data ?? data) as
    | (Representative & { is_available_for_hire?: boolean })[]
    | undefined;
  const normalizedReps = rawReps?.map((r) => ({
    ...r,
    isAvailableForHire: r.isAvailableForHire ?? r.is_available_for_hire,
  })) as Representative[] | undefined;

  return {
    representatives: normalizedReps,
    loading: isLoading,
  };
}
